import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../../dynamicFormBuilder/FormField';
import TransactionSearchFormLayout from './TransactionSearchFormLayout';
import axios from "axios";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import { alert, confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import PlannedAppointment from '../../plannedAppointment/PlannedAppointment';
import StagingAssignments from '../../stagingAssignments/StagingAssignments';
import Transportation from '../../headerOperations/transportation/Transportation';
import TransactionProfile from '../../headerOperations/transactionProfile/TransactionProfile';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const TransactionSearchForm = (props) => {
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const getCarrierUrl =  "wm/TransactionManagement/GetCarrier"
    const [selectedItems, setSelectedItems] = useState(searchpanel);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [showPlannedAppointment, setShowPlannedAppointment] = useState(false);
    const [showStagingAssignments, setShowStagingAssignments] = useState(false);
    const [showTransportation, setShowTransportation] = useState(false);
    const [showTransactionProfile, setShowTransactionProfile] = useState(false);
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        R_CUSTOMER: '',
        TransactionDateFrom: '',
        R_CARRIER: '',
        TransactionDateTo: '',
        CarrierName: '',
        DeliveryDateFrom: '',
        TRANSACTIONNUMBER: '',
        DeliveryDateTo: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = async (e) => {
        e.event.stopPropagation();
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {

    }, []);
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const GetLookupData = async (name, url, accessToken, formRefs, setForceRender, forceRender) => {
        try {
          const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}`, {
            headers: {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            }
          });
          const responseData = response.data;
          if (responseData.success) {
            const newOptions = responseData.lookups.map(item => ({
              id: item.rowid,
              name: item.code
            }));
            if (formRefs.current[name]) {
              formRefs.current[name].instance().option('dataSource', newOptions);
              formRefs.current[name].instance().option('valueExpr', 'id');
              formRefs.current[name].instance().option('displayExpr', 'name');
              setForceRender(!forceRender);
            }
            return newOptions;
          }
          else {
            return null;
          }
        }
        catch (error) {
          return null;
      
          } 
      };
       
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        GetLookupData("R_CARRIER", getCarrierUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);

    return (
    <>
        <form onSubmit={(e) => handleFormSubmit(e)}>
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                  {props.pageTitle}
                                </h6>
                            </div>
                        </Item>

                        <Item location="after">
                            <Button className="accordianButton dx-button-radius" onClick={(e) => handleFormSubmit(e)}  text="Search" type="default" />
                        </Item>
                        {!props.isWebOrderTab && !props.isEdiTab && (
                            <Item location="after">
                                <DropDownButton
                                    text="Operations"
                                    icon="preferences"
                                    dropDownOptions={{ width: 'auto', minWidth: 200 }}
                                    items={[
                                        { id: 'PlannedAppointment', name: 'Planned/Appointment' },
                                        { id: 'StagingAssignments', name: 'Staging/Assignments' },
                                        { id: 'Transportation', name: 'Transportation' }
                                    ]}
                                    displayExpr="name"
                                    keyExpr="id"
                                    onItemClick={(e) => {
                                        if (e.itemData?.id === 'PlannedAppointment') {
                                            if (!props.selectedRowId) {
                                                alert("Please select a transaction first.", "Warning");
                                                return;
                                            }
                                            setShowPlannedAppointment(true);
                                        }
                                        if (e.itemData?.id === 'StagingAssignments') {
                                            if (!props.selectedRowId) {
                                                alert("Please select a transaction first.", "Warning");
                                                return;
                                            }
                                            setShowStagingAssignments(true);
                                        }
                                        if (e.itemData?.id === 'Transportation') {
                                            if (!props.selectedRowId) {
                                                alert("Please select a transaction first.", "Warning");
                                                return;
                                            }
                                            setShowTransportation(true);
                                        }
                                    }}
                                />
                            </Item>
                        )}
                        {props.isWebOrderTab && (
                            <Item location="after">
                                <DropDownButton
                                    text="Operations"
                                    icon="preferences"
                                    dropDownOptions={{ width: 'auto', minWidth: 300 }}
                                    items={[
                                        { id: 'ConvertWebToWM', name: 'Convert Web Transaction to WM Transaction', disabled: !props.selectedRowId },
                                        { id: 'DeleteWebTransaction', name: 'Delete Web Transaction', disabled: !props.selectedRowId },
                                        { id: 'TransactionProfile', name: 'Transaction Profile'}
                                    ]}
                                    displayExpr="name"
                                    keyExpr="id"
                                    itemRender={(itemData) => (
                                        <span style={{ opacity: itemData.disabled ? 0.5 : 1, cursor: itemData.disabled ? 'not-allowed' : 'pointer', pointerEvents: itemData.disabled ? 'none' : 'auto' }}>
                                            {itemData.name}
                                        </span>
                                    )}
                                    onItemClick={async (e) => {
                                        if (e.itemData?.disabled) return;
                                        if (e.itemData?.id === 'ConvertWebToWM') {
                                            const dialogResult = await confirm("Are you sure you want to convert this Web transaction to a WM transaction?", "Confirm");
                                            if (!dialogResult) return;
                                            try {
                                                const response = await axios.post(
                                                    `${window._env_.REACT_APP_APIS}/wm/TransactionManagement/ConvertWebTransactionToWmTransaction?headerId=${props.selectedRowId}`,
                                                    {},
                                                    {
                                                        headers: {
                                                            access_token: accessToken,
                                                            Authorization: `Bearer ${accessToken}`
                                                        }
                                                    }
                                                );
                                                notify(response.data?.message || "Converted successfully.", "success", 3000);
                                                if (props.onGridRefresh) props.onGridRefresh();
                                            } catch (error) {
                                                alert(error?.response?.data || "An error occurred.", "Error");
                                            }
                                        }
                                        if (e.itemData?.id === 'TransactionProfile') {
                                            setShowTransactionProfile(true);
                                            return;
                                        }
                                        if (e.itemData?.id === 'DeleteWebTransaction') {
                                            const dialogResult = await confirm("Are you sure you want to delete this Web transaction?", "Confirm");
                                            if (!dialogResult) return;
                                            try {
                                                const response = await axios.post(
                                                    `${window._env_.REACT_APP_APIS}/wm/Transaction/DeleteTransaction`,
                                                    JSON.stringify(props.selectedRowId),
                                                    {
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                            access_token: accessToken,
                                                            Authorization: `Bearer ${accessToken}`
                                                        }
                                                    }
                                                );
                                                notify("Web transaction deleted successfully.", "success", 3000);
                                                if (props.onGridRefresh) props.onGridRefresh();
                                            } catch (error) {
                                                alert(error?.response?.data || "An error occurred.", "Error");
                                            }
                                        }
                                    }}
                                />
                            </Item>
                        )}
                        {props.isEdiTab && (
                            <Item location="after">
                                <DropDownButton
                                    text="Operations"
                                    icon="preferences"
                                    dropDownOptions={{ width: 'auto', minWidth: 300 }}
                                    items={[
                                        { id: 'ConvertEdiToWM', name: 'Convert EDI Transaction to WM Transaction', disabled: !props.selectedRowId },
                                        { id: 'DeleteEdiTransaction', name: 'Delete Transaction', disabled: !props.selectedRowId },
                                        { id: 'TransactionProfile', name: 'Transaction Profile' }
                                    ]}
                                    displayExpr="name"
                                    keyExpr="id"
                                    itemRender={(itemData) => (
                                        <span style={{ opacity: itemData.disabled ? 0.5 : 1, cursor: itemData.disabled ? 'not-allowed' : 'pointer', pointerEvents: itemData.disabled ? 'none' : 'auto' }}>
                                            {itemData.name}
                                        </span>
                                    )}
                                    onItemClick={async (e) => {
                                        if (e.itemData?.disabled) return;
                                        if (e.itemData?.id === 'ConvertEdiToWM') {
                                            const dialogResult = await confirm("Are you sure you want to convert this EDI transaction to a WM transaction?", "Confirm");
                                            if (!dialogResult) return;
                                            try {
                                                const response = await axios.post(
                                                    `${window._env_.REACT_APP_APIS}/wm/TransactionManagement/ConvertEdiTransactionToWmTransaction?headerId=${props.selectedRowId}`,
                                                    {},
                                                    {
                                                        headers: {
                                                            access_token: accessToken,
                                                            Authorization: `Bearer ${accessToken}`
                                                        }
                                                    }
                                                );
                                                notify(response.data?.message || "Converted successfully.", "success", 3000);
                                                if (props.onGridRefresh) props.onGridRefresh();
                                            } catch (error) {
                                                alert(error?.response?.data || "An error occurred.", "Error");
                                            }
                                        }
                                        if (e.itemData?.id === 'TransactionProfile') {
                                            setShowTransactionProfile(true);
                                            return;
                                        }
                                        if (e.itemData?.id === 'DeleteEdiTransaction') {
                                            const dialogResult = await confirm("Are you sure you want to delete this EDI transaction?", "Confirm");
                                            if (!dialogResult) return;
                                            try {
                                                await axios.post(
                                                    `${window._env_.REACT_APP_APIS}/wm/Transaction/DeleteTransaction`,
                                                    JSON.stringify(props.selectedRowId),
                                                    {
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                            access_token: accessToken,
                                                            Authorization: `Bearer ${accessToken}`
                                                        }
                                                    }
                                                );
                                                notify("EDI transaction deleted successfully.", "success", 3000);
                                                if (props.onGridRefresh) props.onGridRefresh();
                                            } catch (error) {
                                                alert(error?.response?.data || "An error occurred.", "Error");
                                            }
                                        }
                                    }}
                                />
                            </Item>
                        )}
                        <Item location="after">
                            <Button className="accordianButton dx-button-radius" onClick={(e) => handleReset(e)}    text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={(itemProps) => (
                    <div>
                        <FormField
                            currrentUser={currentUser}
                            layoutId='824A9317-2848-4595-A164-BABB1153A41C'
                            layoutName='MyTestForm'
                            defaultFormSchema={TransactionSearchFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
        </form>
        <PlannedAppointment
            visible={showPlannedAppointment}
            onClose={() => setShowPlannedAppointment(false)}
            transactionRowId={props.selectedRowId}
            accessToken={accessToken}
            transactionNumber={props.selectedTransactionNumber || ''}
        />
        <StagingAssignments
            visible={showStagingAssignments}
            onClose={() => setShowStagingAssignments(false)}
            transactionRowId={props.selectedRowId}
            accessToken={accessToken}
            transactionNumber={props.selectedTransactionNumber || ''}
        />
        <Transportation
            visible={showTransportation}
            onClose={() => setShowTransportation(false)}
            transactionRowId={props.selectedRowId}
            accessToken={accessToken}
            transactionNumber={props.selectedTransactionNumber || ''}
        />
        <TransactionProfile
            visible={showTransactionProfile}
            onClose={() => setShowTransactionProfile(false)}
            accessToken={accessToken}
            onGridRefresh={props.onGridRefresh}
            onProfileApply={props.onProfileApply}
        />
    </>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransactionSearchForm);